import React, { Component } from 'react';
import { Input, Button, Form , FormGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FaCircleNotch } from 'react-icons/fa';
import { setField } from '../../../Utilities/Common';
import Actions from '../../../Actions';

class LoginForm extends Component{

    constructor(props){
        super(props);
        this.state = {email: '', password: ''};
    }
    
    setField = (endpoint, option, type = 0) => {
        setField(endpoint, option, type, (dataObj) => {
            this.setState((state) => ({...state,...dataObj}));
        });
    }

    render(){
        const { email, password } = this.state;
        const { loading: { login: loading }, login } = this.props;
        return (
            <Form>
                <FormGroup>
                    <Input id="email" onChange={(event) => this.setField('email',event)} value={ email } type="email" name="email" placeholder="Email" />
                </FormGroup>
                <FormGroup>
                    <Input id="password" onChange={(event) => this.setField('password',event)} value={ password } type="password" name="password" placeholder="Password" />
                </FormGroup>
                <FormGroup>
                    <Button disabled={ loading } onClick={() => {login(email,password)}} block color="primary">
                        {loading ? <FaCircleNotch className="icon-spin" style={{marginRight: '5px', verticalAlign:'text-bottom'}} />:false }
                        Login
                    </Button>
                </FormGroup>
                <FormGroup>
                    <Link to="/request/reset">Forgot Password</Link>
                </FormGroup>
            </Form>
        );
    }
}

const mapStateToProps = (state) => (
    {
      loading: state.auth.loading
    }
);

export default connect(mapStateToProps, Actions.auth)(LoginForm);



// WEBPACK FOOTER //
// ./src/Components/Auth/Layout/LoginForm.js